<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

const model = defineModel({ type: Object, required: true });
const { t } = useI18n();
const kinds = ['general', 'pricing', 'services', 'hours', 'terms'];
const update = (key, value) => {
  model.value = { ...model.value, [key]: value };
};
</script>

<template>
  <div class="grid gap-3 rounded-lg border border-n-weak p-3">
    <label class="text-sm text-n-slate-12">
      {{ t('AI_AGENTS.KNOWLEDGE.FACTS.KIND') }}
      <select
        :value="model.fact_kind || 'general'"
        class="mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 p-2"
        @change="update('fact_kind', $event.target.value)"
      >
        <option v-for="kind in kinds" :key="kind" :value="kind">
          {{ t(`AI_AGENTS.KNOWLEDGE.FACTS.KINDS.${kind}`) }}
        </option>
      </select>
    </label>
    <Input
      :model-value="model.source_reference"
      :label="t('AI_AGENTS.KNOWLEDGE.FACTS.SOURCE')"
      :placeholder="t('AI_AGENTS.KNOWLEDGE.FACTS.SOURCE_HINT')"
      @update:model-value="update('source_reference', $event)"
    />
    <Input
      :model-value="model.responsible_name"
      :label="t('AI_AGENTS.KNOWLEDGE.FACTS.OWNER')"
      @update:model-value="update('responsible_name', $event)"
    />
    <Input
      :model-value="model.valid_until"
      type="date"
      :label="t('AI_AGENTS.KNOWLEDGE.FACTS.VALIDITY')"
      @update:model-value="update('valid_until', $event)"
    />
    <p class="text-xs text-n-slate-11">
      {{ t('AI_AGENTS.KNOWLEDGE.FACTS.HELP') }}
    </p>
  </div>
</template>
